/**
 * Correlation ids carried on requests and logs. Shared by the browser, which
 * mints the view id, and the server, which reads both from headers.
 */

/** Set by the proxy on page requests; one id per server request. */
export const REQUEST_ID_HEADER = "x-request-id";

/** Minted once per browser page load, so concurrent tabs can be told apart. */
export const VIEW_ID_HEADER = "x-view-id";

export interface RequestIds {
	requestId?: string;
	viewId?: string;
}

const SAFE_ID = /^[A-Za-z0-9._-]{1,64}$/;

/** An id from outside the process is only kept when it cannot carry anything else. */
export const safeId = (
	value: string | null | undefined
): string | undefined => {
	const trimmed = value?.trim();
	return trimmed && SAFE_ID.test(trimmed) ? trimmed : undefined;
};

export const readRequestIds = (
	get: (name: string) => string | null | undefined
): RequestIds => ({
	requestId: safeId(get(REQUEST_ID_HEADER)),
	viewId: safeId(get(VIEW_ID_HEADER)),
});
